(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvMenuBar', drvMenuBar);

    drvMenuBar.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvMenuBar
     * 
     * @description
     * Creates a menu bar, which is populated using transclusion.
     * The directives drvMenuBarButton and drvMenuBarDivider are to be used with drvMenuBar.
     * 
     * # Scope Properties
     * {string} iconColor
     * {bool} iconButton - True if the button is to be smaller, just wide enough to display the icon
     */
    function drvMenuBar() {
        var directive = {
            link: link,
            restrict: 'E',
            transclude: true,
            scope: {
                iconColor: '<?',
                iconButton: '<?',
                icon: '<?',
                disabled: '<?'
            },
            template:
                '<div><md-menu md-offset="0 52"><md-button ng-style="disabled && {\'background-color\':\'rgba(0,0,0,0.12)\'}" ng-disabled="disabled" class="md-accent" ng-class="{ \'md-icon-button\': iconButton }" aria-label="Menu" ng-click="$mdMenu.open()"><drv-icon icon="icon" colour="disabled ? \'rgba(0,0,0,0.38)\' : iconColour"></drv-icon></md-button>' +
                '<md-menu-content class="md-dense" ng-transclude>' +
                '</md-menu-content>' + 
                '</md-menu></div>'
        };
        return directive;

        function link(scope, element, attrs) {
            if (_.isNil(scope.icon) || scope.icon !== '') {
                scope.icon = 'menu';
            }
        }
    }
})();